/*** Update environment on integration ***/
import graphql from 'babel-plugin-relay/macro';
import { commitMutation } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

  const abEnvironment = new AbEnvironment();
      
  const mutation = graphql`
  mutation IntegrationSetupMutation($input: UpdateAccountDelegatedAuthsTByAccountDelegatedAuthsIdInput!) {
    updateAccountDelegatedAuthsTByAccountDelegatedAuthsId(input: $input) {
      accountDelegatedAuthsT {
        accountDelegatedAuthsId
        environment
      }
    }
  }
  `;
    
  function commit(adaId, environment, t1) {
    var variables = {
      input: {
        accountDelegatedAuthsId: adaId,
        accountDelegatedAuthsTPatch: {}
      }
    };

    if (environment != null) {
      variables.input.accountDelegatedAuthsTPatch.environment = environment;
    }
    if (t1 != null) {
      variables.input.accountDelegatedAuthsTPatch.t1 = t1;
    }

    return new Promise((resolve, reject) => {
      commitMutation(
        abEnvironment.getEnvironment(), {
          mutation,
          variables,
          onCompleted: (response) => {
            resolve(response);
          },
          onError: (error) => {
            reject(error);
          }
      });
    });
  }
  
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { commit };
  